import type { SanityPageBuilderGeneralGridCard, SanityPageBuilderGridCardsSection, SanityPageBuilderSection } from "@ouster/shared";
import { GridCardsBlockView } from "~/features/blocks/inventory/grid-cards";
import { GeneralCardView, type GeneralCardViewProps } from "~/features/blocks/inventory/grid-cards/general-card";
import { takeFirst } from "~/features/app/utils";
import { toCraftLinkArray } from "~/features/sanity/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderGridCardsSection;
  };
};
type GridCardsViewCard = GeneralCardViewProps & Pick<SanityPageBuilderGeneralGridCard, "_key">;
export function SanityGridCardsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.map<GridCardsViewCard>(card => {
    const cardLink = takeFirst(toCraftLinkArray(card.link));
    const url = isLinkValid(cardLink) && "href" in cardLink ? cardLink.href : undefined;
    const linkText = isLinkValid(cardLink) && "text" in cardLink ? cardLink.text : undefined;
    return {
      _key: card._key,
      hasPlusIcon: false,
      headline: card.title,
      linkText,
      media: hasRenderableSanityMedia(card.media) ? <SanityMediaFigure media={card.media} ratio="496/540" sizes="lg:33vw" /> : undefined,
      text: card.text?.length ? <SanityRichText value={card.text} /> : undefined,
      url
    };
  }) ?? [];
  return <GridCardsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getItemKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} renderCard={card => <GeneralCardView {...card} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}